export default {
  namespaced: true,
  state: {
    notice: null
  },
  getters: {
    notice: state => {
      return state.notice
    }
  },
  mutations: {
    setNotice(state, notice) {
      if (typeof notice !== "string" && notice !== null) return

      if (typeof notice === "string") {
        state.notice = notice
      } else {
        state.notice = null
      }
    }
  },
  actions: {
    setNotice(context, notice) {
      context.commit("setNotice", notice.message)
    },
    deleteNotice(context) {
      context.commit("setNotice", null)
    }
  }
}
